module.exports = __webpack_public_path__ + "img/HQ-PS24-V2_V10_ALL.79d702ea.jpg";